import React from 'react'

const IcCoinStack = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    stroke="currentColor"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8129 3.51789C11.8139 2.49473 9.72756 1.66602 7.15693 1.66602C4.5863 1.66602 2.50186 2.49565 2.5 3.51789M2.5 3.51789C2.5 4.54105 4.58444 5.36976 7.15693 5.36976C9.72942 5.36976 11.8139 4.54105 11.8139 3.51789L11.8139 10.7031M2.5 3.51789V14.629C2.50093 15.6522 4.58537 16.4809 7.15693 16.4809C8.40406 16.4809 9.5301 16.2837 10.3656 15.9661M2.50093 7.22161C2.50093 8.24477 4.58538 9.07349 7.15787 9.07349C9.73036 9.07349 11.8148 8.24477 11.8148 7.22161M10.4214 12.2449C9.58133 12.5736 8.42921 12.7773 7.15693 12.7773C4.58537 12.7773 2.50093 11.9486 2.50093 10.9254M17.106 11.2199C18.7424 12.8467 18.7424 15.4857 17.106 17.1125C15.4696 18.7394 12.8151 18.7394 11.1787 17.1125C9.54221 15.4857 9.54221 12.8467 11.1787 11.2199C12.8151 9.59301 15.4696 9.59301 17.106 11.2199Z"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IcCoinStack
